  import { Modal, Button } from "antd";
import {
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { forwardRef, useState, useImperativeHandle } from "react";
import commonFn from "@/utils/commonFn";

const CustomModal = forwardRef(({
  customConfig
}, ref) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    openModalFn: () => {
      setLoading(false)
      setModalOpen(true)
    },
    closeModalFn: () => {
      setModalOpen(false)
    },
  }));

  const modalOkFn = async() => {
    if(customConfig?.onOkFn) {
      setLoading(true)
      await customConfig?.onOkFn()
      setModalOpen(false)
    }
  }

  const modalCancelFn = () => {
    if(customConfig?.onCancelFn) customConfig?.onCancelFn()
    setModalOpen(false)
  }

  return (
    <Modal
      centered={customConfig?.centered ?? true}
      width={customConfig?.width ?? 416}
      maskClosable={customConfig?.maskClosable ?? false}
      title={customConfig?.title ?? "Complete Request"}
      closable={customConfig?.closable ?? false}   // confirm 无右上角 X
      open={modalOpen}
      onOk={modalOkFn}
      onCancel={modalCancelFn}
      footer={
        customConfig?.footer ?? [
          <Button key="cancel" onClick={modalCancelFn}>
            {customConfig?.cancelText ?? "Cancel"}
          </Button>,
          <Button key="ok" type="primary" onClick={modalOkFn} loading={loading}>
            {customConfig?.okText ?? "OK"}
          </Button>,
        ]
      }
      modalRender={(dom) => (
        <div style={{ padding: "32px 32px 24px" }}>{dom}</div>
      )}
    >
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        {customConfig?.icon ?? (
          <ExclamationCircleOutlined
            style={{ color: "#faad14", fontSize: 22, marginRight: 16 }}
          />
        )}
        <div style={{ fontSize: 16 }}>
          {customConfig?.content ?? `Are you sure to delete this ${customConfig?.deleteContent ?? 'data'}?`}
        </div>
      </div>
    </Modal>
  );
});
export default CustomModal;
